/**
 * @author Fernando Ruano
 * @file constants.js
 * @description App Store Constants
 */

// Generic actions
export const SET_LOADING = 'App/SET_LOADING';
export const SET_RESPONSE = 'App/SET_RESPONSE';
export const SET_TITLE = 'App/SET_TITLE';
export const SET_USER = 'App/SET_USER';
export const SET_PATIENT_INDICATORS = 'App/SET_PATIENT_INDICATORS';
export const SET_PATIENT_EVENT_TYPE = 'App/SET_PATIENT_EVENT_TYPE';
export const SET_CLINIC_ID = 'App/SET_CLINIC_ID';
export const SET_LAST_VERSIA_UPDATE = 'App/SET_LAST_VERSIA_UPDATE';
export const SET_CLINICS = 'App/SET_CLINICS';
export const SET_INSURERS = 'App/SET_INSURERS';
export const SET_TABLE_DATA = 'App/SET_TABLE_DATA';
